import React from 'react';
import BottleLoadingImage from 'images/bottle-loading-image.jpg';
import BottleLoadingImageLarge from 'images/bottle-loading-image-large.jpg';

export default class ProductImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { large, loading, className, alt, title, itemProp } = this.props;
    const product = this.props.product || {};
    const imageSrc = large ? product.image_large : product.image;
    const fallbackSrc = large ? BottleLoadingImageLarge : BottleLoadingImage;
    const src =
      loading || this.state.hasError || !imageSrc ? fallbackSrc : imageSrc;

    return (
      <div style={{ position: 'relative' }}>
        {!!product.watermark && <Watermark url={product.watermark} />}
        <img
          className={className}
          alt={alt || undefined}
          itemProp={itemProp || undefined}
          title={title}
          src={src}
          onError={() => this.setState({ hasError: true })}
        />
      </div>
    );
  }
}

function Watermark({ url }) {
  const style = {
    background: `center / contain no-repeat url(${url})`,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '2.5em',
    height: '2.5em'
  };
  return <div style={style} />;
}
